import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const ShieldWithStar: FC<IconProps> = ({
  color = theme.palette.text.default,
  size = IconSize.medium,
}) => (
  <Icon size={size}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1 3.92074C14.641 3.72673 12.403 2.74765 10.637 1.23252C10.275 0.922494 9.724 0.922494 9.363 1.23252C7.597 2.74665 5.359 3.72673 2.9 3.92074C2.388 3.96075 2 4.39878 2 4.91183V9.24219C2 13.6096 5.156 17.7049 9.478 18.928C9.817 19.024 10.184 19.024 10.523 18.928C14.844 17.7039 18 13.6106 18 9.24319V4.91283C18 4.39878 17.612 3.96075 17.1 3.92074Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 6L11.2358 8.30399L14 8.67575L12 10.468L12.472 13L10 11.804L7.528 13L8 10.468L6 8.67575L8.76379 8.30399L10 6Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
)
